import FestivalDuBonheureSecond from '@containers/IQOSUniverse/articles/FestivalDuBonheureSecond/FestivalDuBonheureSecond';

export default FestivalDuBonheureSecond;
